import moment from "moment";
import {HRMS_STATUS} from "../constant";
import {getDate, localToIST} from "./date";

export const prepareNonWorkingHour = (array = []) => {
    const data = []
    array.forEach((e, i) => {
        const next = array[i + 1]
        const prev = array[i]
        data.push(e)
        if (next?.inTime && prev?.outTime) {
            const obj = {}
            obj.type = HRMS_STATUS?.TIME_SHEET_TYPE.BREAK
            obj.inTime = e.outTime
            if(e.break) obj.break = e.break
            obj.outTime = next.inTime
            obj.totalTime = (new Date(obj.outTime).getTime() - new Date(obj.inTime).getTime()) / 1000
            obj.breakReason = e.breakReason
            obj.inTimeIP = e.outTimeIP
            obj.outTimeFace = next.inTimeFace
            obj.inTimeFace = prev.outTimeFace
            obj.outTimeIP = next.inTimeIP
            obj.prevId = e._id
            obj.nextId = next._id
            obj.inTimeLoginMethod = e.outTimeLoginMethod
            obj.outTimeLoginMethod = next.inTimeLoginMethod
            obj.inTimeIsOffline = e.outTimeIsOffline
            obj.outTimeIsOffline = next.inTimeIsOffline
            data.push(obj)
        }
    })
    return data
}
export const prepareNonWorkingHourDashboard = (array = []) => {
    const data = []
    array.forEach((e, i) => {
        const next = array[i + 1]
        data.push(e)
        if (next) {
            const obj = {}
            obj.type = HRMS_STATUS?.TIME_SHEET_TYPE.BREAK
            obj.inTime = e.outTime
            obj.outTime = next.inTime
            obj.totalTime = (new Date(obj.outTime).getTime() - new Date(obj.inTime).getTime()) / 1000
            obj._id = e._id
            data.push(obj)
        }
    })
    return data
}
export const requestTicket = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (!data.search) delete data.search
    if (data.category) data.category = data?.category?.value ?? data?.category?._id;
    else delete data.category
    if (data.status) data.status = data?.status?.value ?? data?.status?._id;
    else delete data.status
    if (data?.tags?.length > 0) {
        const finalArray = []
        data.tags?.forEach(e => finalArray?.push(e?.value || e?._id))
        data.tags = finalArray
    } else delete data.tags
    // if (data?.employee) data.createdBy = data?.employee?.value ?? data?.employee?._id
    if (data?.createdBy) {
        data.createdBy = data.createdBy?.value ?? data.createdBy?._id;
    } else {
        delete data.createdBy;
    }

    if (data?.resolvedBy) {
        data.resolvedBy = data.resolvedBy?.value ?? data.resolvedBy?._id;
    } else {
        delete data.resolvedBy;
    }

    if (data?.user) {
        data.user = data.user?.value ?? data.user?._id;
    } else {
        delete data.user;
    }
    if (data?.assignTo) data.assignTo = data?.assignTo?.value ?? data?.assignTo?._id
    else delete data.assignTo
    if (data?.priority) data.priority = data?.priority?.value ?? data?.priority?._id
    else delete data.priority
    if (!data?.createdAt?.startDate) delete data.createdAt
    if (!data?.dueDate?.startDate) delete data.dueDate
    if (!data?.resolvedDate?.startDate) delete data.resolvedDate
    if (data?.ticket && data?.ticket !== 'allTicket') {
        if (data?.ticket === 'resolvedTicket') {
            data.isResolved = true
        } else if (data?.ticket === 'openTicket') {
            data.isResolved = false
        } else if (data?.ticket === 'deletedTicket') {
            data.isDeleted = true;
        }
    }
    delete data.ticket

    if (data?.location?.value) data.location = [data.location?.value]
    else delete data.location
    if (data?.companyId?.value) data.companyId = [data.companyId?.value]
    else delete data.companyId


    delete data.employee
    return data
}

export const checkDate = (date) => {
    // 'Older',
    // 'Yesterday',
    // 'Today',
    // 'Tomorrow',
    // 'This Week',
    // 'This Month',
    // 'Upcoming',
    // 'No Due Date'

    const FORMAT = 'YYYY-MM-DD'
    const momentDate = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    const TOMORROW = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_START = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_END = REFERENCE.clone().endOf('week')
    const MONTH_END = REFERENCE.clone().endOf('month').add(1, 'days').startOf('day');
    const MONTH_NEXT = REFERENCE.clone().endOf('month').startOf('day');

    if (momentDate.isBefore(YESTERDAY)) {
        return 'Older';
    } else if (momentDate.isSame(YESTERDAY, 'd')) {
        return 'Yesterday';
    } else if (momentDate.isSame(TODAY, 'd')) {
        return 'Today';
    } else if (momentDate.isSame(TOMORROW, 'd')) {
        return 'Tomorrow';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_START.clone().format(FORMAT), WEEK_END.clone().format(FORMAT))) {
        return 'This Week';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_END.clone().format(FORMAT), MONTH_END.clone().format(FORMAT))) {
        return 'This Month';
    } else if (momentDate.isAfter(MONTH_NEXT)) {
        return 'Upcoming';
    } else {
        return 'No Due Date';
    }
}

export const requestTasks = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));
    if (!data.search) delete data.search;
    if (data.sortBy) data.sortBy = data.sortBy.value;
    if (data.dependencyType) data.dependencyType = data.dependencyType.value;
    if (data.followerTask) {
        if (data.followerTask.value) {
            const key = data.followerTask.value === 'assignToMe' ? 'assignToMe' : data.followerTask.value;
            data[key] = true;
        }
        delete data.followerTask;
    }
    if (data.sections && Array.isArray(data.sections) && data.sections.length)
        data.sections = data.sections.map(e => {
            if (e?.value === null || e?.value === 'null' || e?.value === 'No Section') {
                return null;
            }
            return e?.value || e?._id;
        })
    else delete data.sections
    if (data.tasks) data.tasks = data.tasks.value;
    if (data.withParentTask) data.withParentTask = data.withParentTask?.value;
    if (data.separateTask) data.separateTask = data.separateTask.value;
    if (data.project) data.project = data.project.value;
    if (data.category) data.category = data?.category?.value
    else delete data.category
    if (data?.companyIds?.length) data.companyIds = data.companyIds?.map(e => (e?.value || e?._id))
    else delete data.companyIds
    if (data?.assigneeDepartments && Array.isArray(data?.assigneeDepartments) && data?.assigneeDepartments.length)
        data.assigneeDepartments = data?.assigneeDepartments.map(e => {
            if (e?.value === null || e?.value === 'null' || e?.value === 'No Department') {
                return null;
            }
            return e?.value || e?._id;
        })
    else delete data.assigneeDepartments
    if (data?.milestone?.length) data.milestone = data.milestone?.map(e => (e?.value))
    else delete data.milestone
    if (data?.tag?.length) data.tag = data.tag?.map(e => (e?.value || e?._id))
    else delete data.tag
    if (data?.assignTo && Array.isArray(data?.assignTo) && data?.assignTo?.length) data.assignTo = data.assignTo?.map(e => e?.value === '-' ? null : e?.value)
    else if (data?.assignTo && !Array.isArray(data.assignTo)) data.assignTo = data?.assignTo?.value === '-' ? null : data?.assignTo?.value
    else delete data.assignTo
    if (data?.createdBy && Array.isArray(data?.createdBy) && data?.createdBy?.length) data.createdBy = data?.createdBy?.map(e => e?.value)
    else if (data?.createdBy && !Array.isArray(data?.createdBy)) data.createdBy = data?.createdBy?.value
    else delete data.createdBy
    if (data?.followers && Array.isArray(data?.followers) && data?.followers?.length) data.followers = data?.followers?.map(e => e?.value)
    else if (data?.followers && !Array.isArray(data?.followers)) data.followers = data?.followers?.value
    else delete data.followers
    if (data?.taskAssigner && Array.isArray(data?.taskAssigner) && data?.taskAssigner?.length) data.taskAssigner = data?.taskAssigner?.map(e => e?.value)
    else if (data?.taskAssigner && !Array.isArray(data?.taskAssigner)) data.taskAssigner = data?.taskAssigner?.value
    else delete data.taskAssigner
    if (data?.taskType && Array.isArray(data?.taskType) && data?.taskType?.length) data.taskType = data?.taskType?.map(e => e?.value)
    else if (data?.taskType && !Array.isArray(data?.taskType)) data.taskType = data?.taskType?.value
    else delete data.taskType
    if (Object.prototype.hasOwnProperty.call(data, 'priority') && data?.priority !== undefined) {
        data.priority = data?.priority?.value;
    } else delete data.priority
    if (data.taskCompleted) data.taskCompleted = data?.taskCompleted?.value
    else delete data.taskCompleted
    if (data.taskStatus?.length) data.taskStatus = Array.isArray(data?.taskStatus) ? data.taskStatus?.map(e => e?.value ?? e?._id) : [data?.taskStatus?.value]
    else delete data.taskStatus
    if (data.completedBy?.length) data.completedBy = Array.isArray(data?.completedBy) ? data.completedBy?.map(e => e?.value ?? e?._id) : [data?.completedBy?.value]
    else delete data.completedBy
    if (data?.createdAt) {
        data.createdAt.startDate = new Date(moment(data?.createdAt?.startDate).startOf('day')).getTime();
        data.createdAt.endDate = new Date(moment(data?.createdAt?.endDate).endOf('day')).getTime();
        delete data.createdAt.changeDate
    } else delete data.createdAt
    if (data.startDate) {
        data.startDate.startDate = new Date(moment(data?.startDate?.startDate).startOf('day')).getTime();
        data.startDate.endDate = new Date(moment(data?.startDate?.endDate).endOf('day')).getTime();
        delete data.startDate.changeDate
    } else delete data.startDate
    if (data.completedOn) {
        data.completedOn.startDate = new Date(moment(data?.completedOn?.startDate).startOf('day')).getTime();
        data.completedOn.endDate = new Date(moment(data?.completedOn?.endDate).endOf('day')).getTime();
        delete data.completedOn.changeDate
    } else delete data.completedOn
    if (data.assignedDate) {
        data.assignedDate.startTime = new Date(moment(data?.assignedDate?.startTime).startOf('day')).getTime();
        data.assignedDate.endTime = new Date(moment(data?.assignedDate?.endTime).endOf('day')).getTime();
        delete data.assignedDate.changeDate
    } else delete data.assignedDate
    if (data?.customFieldFilters?.length) {
        data.customFieldFilters = data?.customFieldFilters?.map(c => ({
            _id: c?._id,
            projectCustomFieldType: c?.projectCustomFieldType,
            ...([6].includes(c?.type) ?
                    {
                        value: {
                            startDate: new Date(moment(c?.value?.startDate).startOf('day')).getTime(),
                            endDate: new Date(moment(c?.value?.endDate).endOf('day')).getTime()
                        }
                    }
                    : [8,11].includes(c?.type) ?
                        {value: c?.value?.map(item => {
                                if (item?.user && item?._id) {
                                    return [item?.user, item?._id].filter(Boolean);
                                } else {
                                    return item?.value;
                                }
                            }).flat()}
                        :
                        [1, 5, 9, 12, 13].includes(c?.type) ? {value: c?.value} : [14].includes(c?.type) ? {value: (Array.isArray(c?.value) ? c.value : []).map(c => c?.value)} : {value: (Array.isArray(c?.value) ? c.value : []).map(c => c?.id)}
            ),
        }))
    } else delete data.customFieldFilters
    if (data.customField?.length && data.groupBy === 'customField') {
       data.customField = data.customField?.map(c => c?._id)[0]
    } else delete data.customField

    if (data.dueDate && data.dueDate?.value || data.dueDate?.value === null) {
        switch (data.dueDate?.value || data.dueDate?.value === null) {
            case 'beforeToday': {
                data.beginTime = 0;
                data.endTime = new Date(moment().startOf('day')).getTime() - 1;
                break;
            }
            case 'afterToday': {
                data.beginTime = new Date(moment().endOf('day')).getTime() + 1;
                data.endTime = 0;
                break;
            }
            case 'yesterday': {
                data.beginTime = new Date(moment().subtract(1, 'days').startOf('day')).getTime();
                data.endTime = new Date(moment().subtract(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'today': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'tomorrow': {
                data.beginTime = new Date(moment().add(1, 'days').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.beginTime = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'nextWeek': {
                data.beginTime = new Date(moment().add(1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'next14': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().add(14, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.beginTime = new Date(moment(data?.dueCustomDate?.startDate).startOf('day')).getTime();
                data.endTime = new Date(moment(data?.dueCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                data.beginTime = null;
                data.endTime = null;
                break;
        }
    }
    delete data.dueDate;
    delete data.dueCustomDate;

    if (data.plannedDate && data.plannedDate?.value || data.plannedDate?.value === null) {
        switch (data.plannedDate?.value || data.plannedDate?.value === null) {
            case 'beforeToday': {
                data.plannedStartDate = 0;
                data.plannedEndDate = new Date(moment().startOf('day')).getTime() - 1;
                break;
            }
            case 'yesterday': {
                data.plannedStartDate = new Date(moment().subtract(1, 'days').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().subtract(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'today': {
                data.plannedStartDate = new Date(moment().startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'tomorrow': {
                data.plannedStartDate = new Date(moment().add(1, 'days').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.plannedStartDate = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'nextWeek': {
                data.plannedStartDate = new Date(moment().add(1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'next14': {
                data.plannedStartDate = new Date(moment().startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(14, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.plannedStartDate = new Date(moment(data?.plannedCustomDate?.startDate).startOf('day')).getTime();
                data.plannedEndDate = new Date(moment(data?.plannedCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                data.plannedStartDate = null;
                data.plannedEndDate = null;
                break;
        }
    }
    delete data.plannedDate;
    delete data.plannedCustomDate;

    return data
}
// Recruit/ATS date-range filter — maps a `value` preset (today, thisWeek, …)
// to start/end timestamps. Distinct from `requestTasks` (PMS task filter) above.
export const requestTask = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data?.value) {
        switch (data?.value) {
            case 'today': {
                data.startDate = new Date(moment().startOf('day')).getTime();
                data.endDate = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'yesterday': {
                data.startDate = new Date(moment().add(-1, 'days').startOf('day')).getTime();
                data.endDate = new Date(moment().add(-1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.startDate = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.endDate = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'lastWeek': {
                data.startDate = new Date(moment().add(-1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.endDate = new Date(moment().add(-1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'thisMonth': {
                data.startDate = new Date(moment().startOf('month').startOf('day')).getTime();
                data.endDate = new Date(moment().endOf('month').endOf('day')).getTime();
                break;
            }
            case 'lastMonth': {
                data.startDate = new Date(moment().add(-1, 'month').startOf('month')).getTime();
                data.endDate = new Date(moment().add(-1, 'month').endOf('month')).getTime()
                break;
            }
            case 'last30': {
                data.endDate = new Date(moment().startOf('day')).getTime();
                data.startDate = new Date(moment().add(-30, 'days').endOf('day')).getTime();
                break;
            }
            case 'last60': {
                data.endDate = new Date(moment().startOf('day')).getTime();
                data.startDate = new Date(moment().add(-60, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.startDate = new Date(moment(data?.dueCustomDate?.startDate).startOf('day')).getTime();
                data.endDate = new Date(moment(data?.dueCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                break;
        }
    }
    return data
}
export const planMerger = (planAccess, productAccess, isAdmin) => {
    for (const key in planAccess) {
        if (planAccess[key] && planAccess[key].default) {
            planAccess[key].default.access = planAccess[key].default.access && (isAdmin || productAccess?.[key]);
        }
    }
    return planAccess
}
// Replace [key] tokens in text with their matching [label] from a list
export const convertToLabels = (text = '', list = []) => {
    if (!text || !Array.isArray(list)) return text;

    return text.replace(/\[([^\]]+)\]/g, (_, content) => {
        const value = content.trim();
        const item = list.find(d => String(d.key).trim() === value);
        return item?.label ? `[${item.label}]` : `[${content}]`;
    });
}
// ===== PMS task/report filter builders (migrated from pms/src/common/functions/convert.jsx) =====
export const requestTaskKanban = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));
    if (!data.search) delete data.search;
    if (data.sortBy) data.sortBy = data.sortBy.value;
    if (data.tasks) data.tasks = data.tasks.value;
    if (data.separateTask) data.separateTask = data.separateTask.value;
    if (data.sections && Array.isArray(data.sections) && data.sections.length)
        data.sections = data.sections.map(e => {
            if (e?.value === null || e?.value === 'null' || e?.value === 'No Section') {
                return null;
            }
            return e?.value || e?._id;
        })

    else delete data.sections
    if (data?.milestone?.length) data.milestone = data.milestone?.map(e => (e?.value))
    else delete data.milestone
    if (data?.assigneeDepartments && Array.isArray(data?.assigneeDepartments) && data?.assigneeDepartments.length)
        data.assigneeDepartments = data?.assigneeDepartments.map(e => {
            if (e?.value === null || e?.value === 'null' || e?.value === 'No Department') {
                return null;
            }
            return e?.value || e?._id;
        })
    else delete data.assigneeDepartments
    if (data.assignTo?.length) data.assignTo = Array.isArray(data?.assignTo) ? data.assignTo?.map(e => e?.value === '-' ? null : e?.value) : [data?.assignTo?.value]
    else delete data.assignTo
    if (data.followers?.length) data.followers = Array.isArray(data?.followers) ? data.followers?.map(e => e?.value === '-' ? null : e?.value) : [data?.followers?.value]
    else delete data.followers
    if (data.createdBy?.length) data.createdBy = Array.isArray(data?.createdBy) ? data.createdBy?.map(e => e?.value ?? e?._id) : [data?.createdBy?.value]
    else delete data.createdBy
    if (data?.tag?.length) data.tag = data.tag.filter(e => e?.value?.length > 0).map(e => e?.value || e?._id);
    else delete data.tag;
    if (data.taskType?.length) data.taskType = Array.isArray(data?.taskType) ? data.taskType?.map(e => e?.value ?? e?._id) : [data?.taskType?.value]
    else delete data.taskType
    if (data.priority) data.priority = data.priority.value
    else delete data.priority
    if (data.taskCompleted) data.taskCompleted = data?.taskCompleted?.value
    else delete data.taskCompleted
    if (data.taskStatus?.length) data.taskStatus = Array.isArray(data?.taskStatus) ? data.taskStatus?.map(e => e?.value ?? e?._id) : [data?.taskStatus?.value]
    else delete data.taskStatus
    if (data.completedBy?.length) data.completedBy = Array.isArray(data?.completedBy) ? data.completedBy?.map(e => e?.value ?? e?._id) : [data?.completedBy?.value]
    else delete data.completedBy
    if (data?.createdAt) {
        data.createdAt.startDate = new Date(moment(data?.createdAt?.startDate).startOf('day')).getTime();
        data.createdAt.endDate = new Date(moment(data?.createdAt?.endDate).endOf('day')).getTime();
        delete data.createdAt.changeDate
    } else delete data.createdAt
    if (data.startDate) {
        data.startDate.startDate = new Date(moment(data?.startDate?.startDate).startOf('day')).getTime();
        data.startDate.endDate = new Date(moment(data?.startDate?.endDate).endOf('day')).getTime();
        delete data.startDate.changeDate
    } else delete data.startDate
    if (data.completedOn) {
        data.completedOn.startDate = new Date(moment(data?.completedOn?.startDate).startOf('day')).getTime();
        data.completedOn.endDate = new Date(moment(data?.completedOn?.endDate).endOf('day')).getTime();
        delete data.completedOn.changeDate
    } else delete data.completedOn
    if (data?.customFieldFilters?.length) {
        data.customFieldFilters = data?.customFieldFilters?.map(c => ({
            _id: c?._id,
            projectCustomFieldType: c?.projectCustomFieldType,
            ...([6].includes(c?.type) ?
                    {
                        value: {
                            startDate: new Date(moment(c?.value?.startDate).startOf('day')).getTime(),
                            endDate: new Date(moment(c?.value?.endDate).endOf('day')).getTime()
                        }
                    }
                    : [8,11].includes(c?.type) ?
                        {value: c?.value?.map(item => {
                                if (item?.user && item?._id) {
                                    return [item?.user, item?._id].filter(Boolean);
                                } else {
                                    return item?.value;
                                }
                            }).flat()}
                        :
                        [1, 5, 9, 12, 13].includes(c?.type) ? {value: c?.value} : [14].includes(c?.type) ? {value: (Array.isArray(c?.value) ? c.value : []).map(c => c?.value)} : {value: (Array.isArray(c?.value) ? c.value : []).map(c => c?.id)}
            ),
        }))
    } else delete data.customFieldFilters
    if (data.customField?.length && data.groupBy === 'customField') {
        data.customField = data.customField?.map(c => c?._id)[0]
    } else delete data.customField

    if (data.dueDate && data.dueDate?.value || data.dueDate?.value === null) {
        switch (data.dueDate?.value || data.dueDate?.value === null) {
            case 'beforeToday': {
                data.beginTime = 0;
                data.endTime = new Date(moment().startOf('day')).getTime() - 1;
                break;
            }
            case 'afterToday': {
                data.beginTime = new Date(moment().endOf('day')).getTime() + 1;
                data.endTime = 0;
                break;
            }
            case 'yesterday': {
                data.beginTime = new Date(moment().subtract(1, 'days').startOf('day')).getTime();
                data.endTime = new Date(moment().subtract(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'today': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'tomorrow': {
                data.beginTime = new Date(moment().add(1, 'days').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.beginTime = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'nextWeek': {
                data.beginTime = new Date(moment().add(1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'next14': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().add(14, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.beginTime = new Date(moment(data?.dueCustomDate?.startDate).startOf('day')).getTime();
                data.endTime = new Date(moment(data?.dueCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                data.beginTime = null;
                data.endTime = null;
                break;
        }
    }
    delete data.dueDate;
    delete data.dueCustomDate;

    if (data.plannedDate && data.plannedDate?.value || data.plannedDate?.value === null) {
        switch (data.plannedDate?.value || data.plannedDate?.value === null) {
            case 'beforeToday': {
                data.plannedStartDate = 0;
                data.plannedEndDate = new Date(moment().startOf('day')).getTime() - 1;
                break;
            }
            case 'yesterday': {
                data.plannedStartDate = new Date(moment().subtract(1, 'days').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().subtract(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'today': {
                data.plannedStartDate = new Date(moment().startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'tomorrow': {
                data.plannedStartDate = new Date(moment().add(1, 'days').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.plannedStartDate = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'nextWeek': {
                data.plannedStartDate = new Date(moment().add(1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'next14': {
                data.plannedStartDate = new Date(moment().startOf('day')).getTime();
                data.plannedEndDate = new Date(moment().add(14, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.plannedStartDate = new Date(moment(data?.plannedCustomDate?.startDate).startOf('day')).getTime();
                data.plannedEndDate = new Date(moment(data?.plannedCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                data.plannedStartDate = null;
                data.plannedEndDate = null;
                break;
        }
    }
    delete data.plannedDate;
    delete data.plannedCustomDate;

    return data
}

export const requestDiscussion = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data.subscriptionType) data.subscriptionType = data.subscriptionType.value;
    else delete data.subscriptionType
    if (data.createdBy) data.createdBy = data.createdBy.value;
    else delete data.createdBy
    if (data.sortByOrder) data.sortByOrder = data.sortByOrder.value;
    else delete data.sortByOrder

    return data
}

export const requestFiles = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data?.search === '') delete data.search;
    if (data?.sort === '') delete data.sort;
    if (data?.tag?.length) data.tag = data?.tag?.map(tag => tag?.value);
    else delete data.tag

    return data
}

export const getAutomationRoute = (automationId, projectNumber = null) => {
    if(projectNumber){
        // Redirection from Task Approval ACtivity 
        const path = window.location.pathname.split('/');
        return `/${path[1]}/${projectNumber}/task-automation/manage/read/${automationId}`;
    }else {
        const path = window.location.pathname.split('/');
        return `/${path[1]}/${path[2]}/task-automation/manage/read/${automationId}`;
    }
    
}

export const requestTimeSheet = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));
    if (data.client) {
        data.client = data?.client?.value;
    } else data.client = 'all'
    if (data.project) {
        const finalArray = []
        data.project?.forEach(e => finalArray?.push(e.value))
        data.project = finalArray
    } else data.project = 'all'
    if (data.user) {
        const finalArray = []
        data.user?.forEach(e => finalArray?.push(e.value))
        data.user = finalArray
    } else data.user = 'all'
    data.beginTime = localToIST(data.beginTime, 'start')
    data.endTime = localToIST(data.endTime, 'end')
    if (data?.userType === 'active' && data.user === 'all') {
        data.user = 'active'
    } else if (data?.userType === 'inactive' && data.user === 'all') {
        data.user = 'inActive'
    }
    if (data.isBillable === null) delete data.isBillable
    if (data.taskBillingType === null) delete data.taskBillingType
    if (data.addedManually === null) delete data.addedManually
    if (data?.departments?.length) {
        data.departments = data.departments.map(e => e.value || e._id || e)
    } else delete data.departments
    if (data?.jobTitles?.length) {
        data.jobTitles = data.jobTitles.map(e => e.value || e._id || e)
    } else delete data.jobTitles
    if (data?.projectManagers?.length) {
        data.projectManagers = data.projectManagers.map(e => e.value || e._id || e)
    } else delete data.projectManagers
    if (data?.projectOwners?.length) {
        data.projectOwners = data.projectOwners.map(e => e.value || e._id || e)
    } else delete data.projectOwners
    return data
}

export const requestBillingReports = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));
    if (data.user) {
        data.user = data?.user?.value
    } else delete data.user
    if (!data.search) delete data.search
    if (data.isBillable === null) delete data.isBillable
    if (data.type === null) delete data.type
    data.from = new Date(getDate(data.from, 'start')).getTime() // start date for employee vise report
    data.to = new Date(getDate(data.to, 'end')).getTime() // end date for employee vise report
    data.beginTime = new Date(getDate(data.beginTime, 'start')).getTime()
    data.endTime = new Date(getDate(data.endTime, 'end')).getTime()

    return data
}

export const requestReport = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data?.project?.length === 1) data.project = data?.project[0]?.value
    else if (Array.isArray(data.project)) data.project = data?.project?.map(_ => _?.value) ?? []
    // if (data?.users && data?.users?.length === 0) delete data.users
    if (data?.assignBy) data.assignBy = data?.assignBy?.value
    // else delete data.assignBy
    if (data?.tasks) data.tasks = data?.tasks?.value
    // else delete data.tasks
    if (data?.trackingType) data.trackingType = data?.trackingType?.value
    // else delete data.trackingType
    if (data?.availability && data?.availability?.value) data.availability = data?.availability?.value
    // else delete data.availability
    if (data?.pendingTasks) data.pendingTasks = data?.pendingTasks?.value
    // else delete data.pendingTasks
    if (data?.assignTo?.length) data.assignTo = data?.assignTo?.map(_ => _?.value) ?? []
    // else delete data.assignTo
    if (data?.activityType?.length) data.activityType = data?.activityType?.map(_ => _?.value) ?? []
    // else delete data.activityType
    if (data?.taskType?.length) data.taskType = data?.taskType?.map(_ => _?.value) ?? []
    // else delete data.taskType
    if (data?.taskStatus?.length) data.taskStatus = data?.taskStatus?.map(_ => _?.value) ?? []
    // else delete data.taskStatus
    if (data?.projectManager?.length) data.projectManager = data?.projectManager?.map(_ => _?.value) ?? []
    // else delete data.projectManager
    if (data?.customFieldFilters && data?.customFieldFilters?.length !== 0) {
        data.customFieldFilters = data?.customFieldFilters?.map(c => ({
            _id: c?._id,
            projectCustomFieldType: c?.projectCustomFieldType,
            ...([6].includes(c?.type) ?
                    {
                        value: {
                            startDate: new Date(moment(c?.value?.startDate).startOf('day')).getTime(),
                            endDate: new Date(moment(c?.value?.endDate).endOf('day')).getTime()
                        }
                    } : [5].includes(c?.type) ? {value: {startDate: (c?.value?.startDate ?? 0)*3600, endDate: (c?.value?.endDate ?? 0)*3600}}
                    : {value: c?.value}
            ),
        })).filter(c => c?.value)
    }
    // else delete data.customFieldFilters

    return data
}

export const requestMilestone = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (!data?.search) delete data.search
    if (filter?.startDate) {
        data.startDate = getDate(filter?.startDate?.startDate)
        data.endDate = getDate(filter?.startDate?.endDate, 'end')
    } else delete data.startDate
    if (data.sortBy) data.sortBy = data?.sortBy?.value
    else delete data.sortBy
    if (data.isCompleted?.value !== '') data.isCompleted = data?.isCompleted?.value
    else delete data.isCompleted
    delete data.tag;
    if (filter?.tag) {
        const tagName = filter?.tag?.name || filter?.tag?.label || (typeof filter?.tag === 'string' ? filter?.tag : filter?.tag?.value);
        if (tagName) data.tagName = tagName;
    }
    if (data.project) data.project = data?.project?._id
    else delete data.project
    if (data.owner) data.owner = data.owner?._id
    else delete data.owner

    return data
}

export const requestWorkDiaryReport = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data?.user) data.user = data?.user?.value ?? ''
    else delete data.user
    if (data?.department) data.department = data?.department?.value ?? ''
    else delete data.department

    return data
}
